import { Note as NoteModel } from '../common/note.model';
import { SimpleEntityActions } from '@app/classes';

export class Note extends NoteModel {
    protected static _resource = 'companyManagement/companies/:company/employees/:employee/notes';

    static permission = new SimpleEntityActions('employeeNote');
}
